"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// BE api endpoints
exports.default = {
    BASE_URL: {
        local: 'https://dev.lumirental.com',
        development: 'https://dev.lumirental.com',
        staging: 'https://staging.lumirental.com',
        production: 'https://lumirental.com',
    },
    BRANCH_SERVICE: {
        BRANCH: '/api/branch-service/branch',
        BRANCH_LIST: '/api/branch-service/branch/detailed-list',
        BRANCH_ID: '/api/branch-service/branch/{branchId}',
        CITY: '/api/branch-service/city',
        REGION: '/api/branch-service/region',
        COUNTRY: '/api/branch-service/country?sort=position&order=asc',
    },
    FLEET_SERVICE: {
        CLASS: '/api/fleet-service/class',
        ADDON: '/api/fleet-service/addon/list/quote/{quoteId}',
        GROUP_LIST: '/api/fleet-service/group',
        MAKE: '/api/fleet-service/make',
        MODEL: '/api/fleet-service/model',
        INSURANCE: '/api/fleet-service/insurance',
        GROUP_DETAILS: '/api/fleet-service/group/{groupId}/details',
    },
    EXPERIENCE_FEEDBACK: {
        QUESTIONS: '/api/feedback-service/questions',
    },
    TARIFF_SERVICE: {
        PRICE: '/api/tariff-service/tariff/price',
        PRICE_V2: '/api/tariff-service/tariff/v2/price',
        PRICE_V3: '/api/tariff-service/tariff/v3/price',
        QUOTE: '/api/tariff-service/tariff/price/{searchId}/quote/{groupId}',
        QUOTE_V2: '/api/tariff-service/tariff/v2/price/{searchId}/quote/{groupId}',
        QUOTE_DETAILS: '/api/tariff-service/tariff/quote/details/{quoteId}',
        QUOTE_DETAILS_V2: '/api/tariff-service/tariff/v2/quote/details/{quoteId}',
        VALIDATE_PROMO_CODE: '/api/tariff-service/promotion/validate/{quoteId}?code={promoCode}',
        VALIDATE_PROMO_CODE_V2: '/api/tariff-service/lumi/promotion/validate?code={promoCode}&quoteId={quoteId}',
        GROUP_TARIFF: '/api/tariff-service/tariffCard/list?groupCodes={groupCodes}',
        PROMO_LIST: '/api/tariff-service/lumi/promotion/active?quoteId={quoteId}',
        CORPORATE_PARTNER_LIST: '/api/tariff-service/lumi/promotion/corporate/active?quoteId={quoteId}',
        CDP_DOMAIN_VERIFY: '/api/tariff-service/lumi/promotion/corporate/domain/verify',
        DROP_OFF_CHARGES: '/api/tariff-service/drop-off-charge',
    },
    CUSTOMER_SERVICE: {
        GENERATE_OTP: '/api/customer-service/otp',
        GENERATE_OTP_FORGOT_PWD: '/api/customer-service/otp/forgotPassword',
        VERIFY_OTP: '/api/customer-service/otp/verify',
        VERIFY_EMAIL: '/api/customer-service/customer/verify/email',
        FIND: '/api/customer-service/customer/find',
        LOGIN: '/api/customer-service/login',
        REGISTER: '/api/customer-service/customer/register',
        PROFILE: '/api/customer-service/customer/profile',
        DRIVER: '/api/customer-service/customer/driver',
        DRIVER_DOCUMENTS: '/api/customer-service/driver/documents',
        FORGOT_PWD: '/api/customer-service/customer/forgotPassword',
        DOCUMENT_UPLOAD: '/api/customer-service/driver/upload',
        GENERATE_CDP_OTP: '/api/customer-service/otp/corporate/email',
        VERIFY_CDP_OTP: '/api/customer-service/otp/corporate/verify',
        SAVE_CARD: '/api/customer-service/customer/card/{cardId}',
    },
    BOOKING_SERVICE: {
        REGISTER_DRIVER: '/api/booking-service/checkout/register/{quoteId}',
        PAYMENT: '/api/booking-service/checkout/payment/{quoteId}',
        PAYMENT_EXTENSION: '/api/booking-service/checkout/payment/extension/{extensionId}',
        PAYMENT_STATUS: '/api/booking-service/checkout/status',
        PAYMENT_METHODS: '/api/booking-service/checkout/payment/methods/{quoteId}',
        PAYMENT_METHODS_EXTENSION: '/api/booking-service/booking/payment/methods/extension',
        BOOKING_DETAILS: '/api/booking-service/booking/details/{refId}',
        BOOKING_LIST: '/api/booking-service/booking/list?sort=pickupDateTime&order=desc',
        UPDATE_FLIGHT: '/api/booking-service/booking/{refId}/flight/{flightNo}',
        APPLE_PAY_VALIDATE_SESSION: '/api/booking-service/checkout/session',
        REWARDS: '/api/booking-service/booking/{bookingDisplayId}/reward/details',
        CANCEL_BOOKING: '/api/booking-service/booking/cancel/{refId}',
        QUICK_PAY: '/api/booking-service/checkout/quickPay/{trackId}/status',
        QUICK_PAY_PAYMENT: '/api/booking-service/checkout/quickPay/{trackId}/initiate',
        CALCULATOR: '/api/booking-service/booking/price/calculator/extension',
    },
    POLICY_SERVICE: {
        RENTAL_POLICIES: '/api/policy-service/policy/list',
    },
    LOYALTY_SERVICE: {
        VALIDATE_ALFURSAN: '/api/loyalty-service/v1/reward/alfursan/validate/{identifier}',
        CALCULATOR: '/api/loyalty-service/v1/reward/calculate',
    },
};
